<template>
  <div class="mainBody">
    <v-overlay v-if="syncing" z-index="998">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <div v-if="isThankyouPage == false" class="container" id="feedback-container">
      <h1>We Value Your Feedback!</h1>
      <p class="description">Thank you for shopping with us. Let us know about your experience!</p>
      <div class="product-info" v-if="order">
        <p class="product-title">{{ products[productCount].title }}</p>
        <img :src="products[productCount].image" alt="Your Purchased Product">
      </div>

      <form id="feedback-form">
        <div class="form-group">
          <label for="rating">Rate Your Experience:</label>
          <div class="rating">
            <input type="radio" id="star5" name="rating" value="5" v-model="review.rating">
            <label for="star5">★</label>
            <input type="radio" id="star4" name="rating" value="4" v-model="review.rating">
            <label for="star4">★</label>
            <input type="radio" id="star3" name="rating" value="3" v-model="review.rating">
            <label for="star3">★</label>
            <input type="radio" id="star2" name="rating" value="2" v-model="review.rating">
            <label for="star2">★</label>
            <input type="radio" id="star1" name="rating" value="1" v-model="review.rating">
            <label for="star1">★</label>
          </div>
        </div>
        <div class="form-group">
          <label for="comments">Additional Comments:</label>
          <textarea id="comments" name="comments" rows="5" v-model="review.description"
            placeholder="Write your feedback here..."></textarea>
        </div>
        <p class="highlight">Upload pictures of your experience and get an additional 10% discount!</p>
        <div class="form-group">
          <label for="media-upload">Upload Media:</label>
          <div class="drag-drop" id="drag-drop">
            Drag & Drop your pictures here or click to upload
            <input type="file" id="media-upload" name="media-upload" accept="image/*" @change="getInputSelectFiles"
              multiple>
          </div>
        </div>
        <v-btn @click="createReview()" class="btn">Submit Feedback</v-btn>
      </form>

    </div>
    <div v-if="isThankyouPage" class="container" id="thank-you-page">
      <div class="thank-you">
        <h1>Thank You for Your Feedback!</h1>
        <p>We appreciate your time and effort to share your experience with us.</p>
        <p class="discount-code">Your discount code: <strong id="discount-code">{{ discountCode }}</strong></p>
        <p>You received a <strong id="discount-amount">{{ discount }}% discount</strong> for submitting your feedback!
        </p>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { BASE_URL } from "./baseUrl";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

export default {
  name: "FeedbackNewView",
  data() {
    return {
      orderId: "",
      productId: "",
      order: null,
      productDetail: "",
      snackbar: false,
      snackBarText: "",
      products: [],
      productCount: 0,
      uploadDialog: false,
      dragover: false,
      uploadedFiles: [],
      multiple: false,
      review: {
        rating: 5,
        description: "",
        product_id: 0,
        review_id: 0,
      },
      reviewMedia: {
        review_id: 0,
        link: "",
      },
      reviewMediaList: [],
      options: {
        headers: {
          "Access-Control-Allow-Headers":
            "X-Custom-Header, Access-Control-Request-Headers",
          //"x-access-token": localStorage.getItem("token"),
          //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
        },
      },
      storageRef: null,
      file: null,
      syncing: false,
      isThankyouPage: false,
      isMedia: false,
      discountCode: "",
      discount: 5
    };
  },
  mounted() {
    this.orderId = this.$route.query.orderId;


    var url = BASE_URL + `orders/orderWithProductReviews?orderId=${this.orderId}`;
    axios
      .get(url, this.options)
      .then((response) => {
        this.order = response.data;

       
        if (this.order.review?.coupon != null && this.order.review?.coupon != "") {
          this.isThankyouPage = true;
          this.discountCode = this.order.review?.coupon
          this.discount = this.order.review?.discount
        } else {
          const reviewedProductIds = this.order.review?.review_products.map(rp => rp.product_id.toString());
          this.products = this.order.order_products.filter(product => !reviewedProductIds?.includes(product.product_id));
          this.productCount = 0;
        }

      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {

    async createReview() {
      this.syncing = true;
      await this.uploadFeedbackFiles();
      console.log(this.order)
      this.review.review_id = this.order.review.id;
      this.review.product_id = this.products[this.productCount].product_id;
      let newReview = {
        isCompleted: false,
        isMedia: this.isMedia,
        review: this.review,
      };
      if (this.products.length == this.productCount + 1) {
        // route to thank you page
        this.isThankyouPage = true;
        newReview.isCompleted = true;
      }
      console.log(newReview);
      var url = BASE_URL + `reviews/`;
      await axios
        .post(url, newReview, this.options)
        .then((response) => {
          console.log(response);
          if (response.data.hasError == false) {
            //this.snackbar = true;
            //this.snackBarText = response.data.message;
            this.review.description = "";
            if (newReview.isCompleted) {
              this.discountCode = response.data.message
              if (this.isMedia) {
                this.discount = 10
              }
            }
            this.productCount += 1;

          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false, this.syncing = false));
      if (!this.isThankyouPage) {
        this.resetForm()
      }
      console.log(this.review);
    },
    getInputSelectFiles() {
      //console.log(event.target.files.length)
      var selectedFiles = event.target.files
      for (var i = 0; i < selectedFiles.length; i++) {
        this.uploadedFiles.push(selectedFiles[i])
      }
      console.log(this.uploadedFiles)
    },
    getFeedbackFiles() {
      //this.file = event.target.files[0];
      console.log(this.uploadedFiles);
      this.upload();
    },

    async upload() {
      if (this.uploadedFiles.length > 0) {
        this.isMedia = true;
      }

      const storage = getStorage();
      const uploadPromises = this.uploadedFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const storageRef = ref(storage, "images/" + file.name);
          const uploadTask = uploadBytesResumable(storageRef, file);

          uploadTask.on(
            "state_changed",
            null, // Progress function (optional)
            (error) => {
              // Handle errors
              console.error("Upload error:", error);
              reject(error);
            },
            async () => {
              // Get the download URL once the upload completes
              try {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                console.log("Uploaded file URL:", downloadURL);

                const media = {
                  review_id: this.order.review.id,
                  link: downloadURL,
                  product_id: this.products[this.productCount].product_id,
                };
                this.reviewMediaList.push(media);
                resolve(media); // Resolve the promise with the media object
              } catch (error) {
                console.error("Error fetching download URL:", error);
                reject(error);
              }
            }
          );
        });
      });

      // Wait for all upload promises to resolve
      return Promise.all(uploadPromises);
    },

    async uploadFeedbackFiles() {
      if (this.uploadedFiles.length > 0) {
        this.isMedia = true;
      }
      const formData = new FormData()
      this.uploadedFiles.forEach((file, index) => {
        formData.append('images', file); // multer reads this
      });

      // Append additional fields
      formData.append('productId', this.products[this.productCount].product_id);
      formData.append('reviewId', this.order.review.id);

      // Send the form
      var url = BASE_URL + "reviews/feedbackFiles"
      await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },

    resetForm() {
      document.getElementById("feedback-form").reset();
      this.review = {
        review_id: "",
        product_id: "",
        description: "",
        rating: 0, // Reset to initial rating
      };
      this.reviewMediaList = []; // Clear uploaded media list
      this.uploadedFiles = [];   // Clear uploaded files
      this.file = null;          // Reset file reference
      this.syncing = false;      // Reset syncing state
      this.errored = false;      // Reset error state
      console.log("Form has been reset.");
    },



  },
};
</script>

<style scoped>
.mainBody {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f8f4f4;
  margin-top: -50px;
}

.container {
  max-width: 600px;
  margin: 50px auto;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  text-align: center;
  color: #333;
}

.description {
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
  color: #555;
}

.product-info {
  text-align: center;
  margin-bottom: 20px;
}

.product-info img {
  display: block;
  margin: 10px auto;
  max-width: 100px;
}

.product-info .product-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  color: #444;
}

.form-group input[type="text"],
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  color: #555;
}

.form-group textarea {
  resize: vertical;
}

.rating {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.rating input {
  display: none;
}

.rating label {
  font-size: 24px;
  color: #ccc;
  cursor: pointer;
}

.rating input:checked~label,
.rating input:hover~label {
  color: #f39c12;
}

.btn {
  display: block;
  width: 100%;
  padding: 12px;
  background: #e91e63 !important;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s;
}

.btn:hover {
  background: #d81b60;
}

.drag-drop {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  color: #888;
  font-size: 14px;
  margin-bottom: 15px;
  cursor: pointer;
  animation: pulse 2s infinite;
  transition: border-color 0.3s, color 0.3s;
}

.drag-drop:hover {
  border-color: #e91e63;
  color: #e91e63;
}

.highlight {
  font-weight: bold;
  color: #e91e63;
  margin-top: 10px;
}

.thank-you {
  text-align: center;
  margin-top: 20px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.thank-you img {
  max-width: 100px;
  margin-bottom: 10px;
}

.thank-you p {
  font-size: 16px;
  margin: 5px 0;
  color: #333;
}

.thank-you .discount-code {
  font-weight: bold;
  color: #e91e63;
  margin: 10px 0;
}

.secondary-form {
  margin-top: 20px;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 5px rgba(233, 30, 99, 0.3);
  }

  50% {
    transform: scale(1.05);
    box-shadow: 0 0 15px rgba(233, 30, 99, 0.5);
  }
}
</style>